var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9501\u5B9A\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406",
    transform: "translate(-1381.000000, -307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9501\\u5B9A\\u5907\\u4EFD",
    transform: "translate(1381.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8333333,5.83376551 C12.2015232,5.83376551 12.5,6.13224234 12.5,6.50043217 L12.5,11.5837655 C12.5,11.9519553 12.2015232,12.2504322 11.8333333,12.2504322 L2.66666667,12.2504322 C2.29847683,12.2504322 2,11.9519553 2,11.5837655 L2,6.50043217 C2,6.13224234 2.29847683,5.83376551 2.66666667,5.83376551 L11.8333333,5.83376551 Z M7.22411211,1 C8.83492878,1 10.1407788,2.30583542 10.1407788,3.91666667 L10.1407788,5.81273588 L4.30744545,5.81273588 L4.30744545,3.91666667 C4.30744545,2.30583542 5.61329545,1 7.22411211,1 Z M7.25,8.16709884 L7.25,9.91709884",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#999999",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnLock);
export default __webpack_public_path__ + "static/media/un-lock.f2fbf8dbc0baa1800c5e1f4e4d1ae6d0.svg";
export { ForwardRef as ReactComponent };